import React, { useState, useCallback } from "react";
import { Callout } from "@blueprintjs/core";
import { Tag, NonIdealState } from "@blueprintjs/core";

function ErrorItem({ error, setErrors }) {
  const title = error.title || error.message;
  const code = error.code || '';
  return (
    <div className="bp3-code">
      {code ? `${code}: `: ''}
      {title}
      {setErrors && (
        <Tag
          style={{
            float: "right",
          }}
          interactive="true"
          icon="cross"
          onClick={() =>
            setErrors((errors) =>
              errors.filter((errorItem) => errorItem !== error)
            )
          }
        />
      )}
    </div>
  );
}

export function ErrorCallout({ errors, setErrors }) {
  if (!errors || !errors.length) {
    return null;
  }

  return (
    <Callout title="Something Went Wrong!" intent="danger">
      {errors.map((error) => {
        return (
          <ErrorItem key={error.id + error.title} error={error} setErrors={setErrors} />
        );
      })}
    </Callout>
  );
}

export function ErrorState({ errors }) {
  if (!errors || !errors.length) {
    return null;
  }

  return (
    <NonIdealState
      icon="error"
      title="Something Went Wrong!"
      description={errors.map((error) => error.title)}
    />
  );
}

export function extractSingleError(excpt) {
  try {
    let e = excpt.response.data.errors[0].title;
    if (e) {
      if (excpt.response.data.errors[0].code) {
        e = excpt.response.data.errors[0].code + ' ' + e;
      }
      return e;
    }
  } catch (e) {
  }
  return excpt.message;
}

export function useError() {
  const [errors, setErrors] = useState([]);

  const handleError = useCallback(
    (excpt) => {
      try {
        excpt.response.data.errors.map((err) =>
          setErrors((errors) => [{...err, id: Date.now()}, ...errors])
        );
      } catch (e) {
        setErrors((errors) => [{ title: excpt.message, id: Date.now() }, ...errors]);
      }
    },
    [setErrors]
  );

  return {
    errors,
    setErrors,
    handleError,
  };
}

const Errors = {
  Callout: ErrorCallout,
  useError,
};
export default Errors;
